import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FixedPriceComponent } from './components/fixed-price-tab/fixed-price.component';
import { FixedPriceShellComponent } from './containers/fixed-price-shell/fixed-price-shell.component';
import * as fromFixedPrice from './store/reducer';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { FixedPriceEffects } from './store/effects';
import { EfaactMaterialModule } from '../efaact-material/efaact-material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MultiSelectModule } from '../shared/efaact-primeng.module';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  imports: [
    CommonModule
    , StoreModule.forFeature('fpinvoices', fromFixedPrice.reducer)
    , EffectsModule.forFeature([FixedPriceEffects])
    , EfaactMaterialModule
    , FormsModule
    , ReactiveFormsModule
    , MultiSelectModule
    , SharedModule
  ],
  declarations: [FixedPriceComponent, FixedPriceShellComponent]
})
export class FixedPriceModule { }
